import { FIELD_LITHOLOGY_LIST, FIELD_LITHOLOGY_LIST_ERROR, FIELD_LITHOLOGY_LIST_SUCCESS, FIELD_LITHOLOGY_UPDATE_DATA, OPEN_MODAL } from './constants';

export default function fieldLithologyManagementReducer(state, action) {
	let lithologyData = [];
	switch (action.type) {
	case OPEN_MODAL :
		return { ...state, openModal : action.payload };
	case FIELD_LITHOLOGY_LIST :
		return { ...state, loading : true, error : false};
	case FIELD_LITHOLOGY_LIST_SUCCESS :
		action.payload.data && action.payload.data.map((item) => {
			lithologyData.push({
				id : item.id,
				name : item.name,
				wellFieldId: item.wellFieldId,
				wellFieldName : item.wellfields.name,
				lithologylayer : item?.lithologyData?.layers,
				lithologydepths	: item?.lithologyData?.depths,
				lithologycolors	: item?.lithologyData?.colors,
				lithologydensities : item?.lithologyData?.densities,
				lithologyvelocities	: item?.lithologyData?.velocities,
				lithologyData : item?.lithologyData
			
			});
		});
		return { ...state, loading : false, error : false, fieldLithologyData : lithologyData};
	case FIELD_LITHOLOGY_LIST_ERROR : 
		return { ...state, loading : false, error : true};
	case FIELD_LITHOLOGY_UPDATE_DATA:
		return { ...state, updateData : action.payload };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}